/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_HoursInputs */

const en_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon to Sun, 8:00am to Dark (weather permitting)`)
};

const es_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lun a Dom, 8:00 a. m. hasta el anochecer (según el clima)`)
};

const de_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montag bis Sonntag, 8:00 Uhr bis Einbruch der Dunkelheit (wetterabhängig)`)
};

const zh_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`周一至周日，上午 8:00 至天黑（天气允许时）`)
};

const ar_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من الاثنين إلى الأحد، من 8:00 صباحاً حتى الغروب، حسب الطقس`)
};

const fr_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du lundi au dimanche, de 8h00 à la tombée de la nuit (si le temps le permet)`)
};

const vi_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thứ Hai đến Chủ Nhật, 8:00 sáng đến khi trời tối (tùy thời tiết)`)
};

const sw_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumatatu hadi Jumapili, 8:00 asubuhi hadi giza (hali ya hewa inaruhusu)`)
};

const th_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จันทร์ถึงอาทิตย์ 08.00 น. ถึงมืด (ขึ้นอยู่กับสภาพอากาศ)`)
};

const bs_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponedjeljak do nedjelje, od 8.00 do mraka, ako vremenske prilike dozvole`)
};

const ja_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月曜から日曜、午前8時〜暗くなるまで（天候が許せば）`)
};

const ko_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월~일, 오전 8시부터 해 질 때까지 (날씨에 따라)`)
};

const pt_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seg a Dom, das 8:00 até escurecer (se o tempo permitir)`)
};

const it_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lun–Dom, dalle 8:00 al buio (tempo permettendo)`)
};

const sv_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mån–sön, 8:00 till mörker (om vädret tillåter)`)
};

const nl_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma tot Zo, 8:00 tot donker (weer toegestaan)`)
};

const da_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Man–søn, 8:00 til mørke (vejret tillader)`)
};

const nb_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Man–søn, 8:00 til mørkt (hvis været tillater det)`)
};

const fi_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma–su, klo 8.00–pimeään (sään salliessa)`)
};

const pl_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pon–niedz., od 8:00 do zmroku (w zależności od pogody)`)
};

const ru_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пн–Вс, с 8:00 до темноты (если позволяет погода)`)
};

const tr_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pzt–Paz, 08:00’den karanlığa kadar (hava koşullarına bağlı)`)
};

const hi_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सोम से रवि, सुबह 8:00 से अँधेरा होने तक (मौसम अनुकूल होने पर)`)
};

const id_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sen–Min, pukul 8:00 hingga gelap (tergantung cuaca)`)
};

const ms_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isnin–Ahad, pukul 8:00 pagi hingga gelap (tertakluk kepada cuaca)`)
};

const cs_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po–Ne, 8:00 do setmění (dle počasí)`)
};

const el_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δευ–Κυρ, 8:00 π.μ. έως το σούρουπο (καιρού επιτρέποντος)`)
};

const he_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ב׳ עד א׳, 8:00 עד חשכה (בהתאם למזג האוויר)`)
};

const af_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma tot So, 8:00 tot donker (weer toegelaat)`)
};

const hu_site_hours = /** @type {(inputs: Site_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hétfőtől vasárnapig, 8:00-tól sötétedésig (időjárás függvényében)`)
};

/**
* | output |
* | --- |
* | "Mon to Sun, 8:00am to Dark (weather permitting)" |
*
* @param {Site_HoursInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const site_hours = /** @type {((inputs?: Site_HoursInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_HoursInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_site_hours(inputs)
	if (locale === "de") return de_site_hours(inputs)
	if (locale === "zh") return zh_site_hours(inputs)
	if (locale === "ar") return ar_site_hours(inputs)
	if (locale === "fr") return fr_site_hours(inputs)
	if (locale === "vi") return vi_site_hours(inputs)
	if (locale === "sw") return sw_site_hours(inputs)
	if (locale === "th") return th_site_hours(inputs)
	if (locale === "bs") return bs_site_hours(inputs)
	if (locale === "ja") return ja_site_hours(inputs)
	if (locale === "ko") return ko_site_hours(inputs)
	if (locale === "pt") return pt_site_hours(inputs)
	if (locale === "it") return it_site_hours(inputs)
	if (locale === "sv") return sv_site_hours(inputs)
	if (locale === "nl") return nl_site_hours(inputs)
	if (locale === "da") return da_site_hours(inputs)
	if (locale === "nb") return nb_site_hours(inputs)
	if (locale === "fi") return fi_site_hours(inputs)
	if (locale === "pl") return pl_site_hours(inputs)
	if (locale === "ru") return ru_site_hours(inputs)
	if (locale === "tr") return tr_site_hours(inputs)
	if (locale === "hi") return hi_site_hours(inputs)
	if (locale === "id") return id_site_hours(inputs)
	if (locale === "ms") return ms_site_hours(inputs)
	if (locale === "cs") return cs_site_hours(inputs)
	if (locale === "el") return el_site_hours(inputs)
	if (locale === "he") return he_site_hours(inputs)
	if (locale === "af") return af_site_hours(inputs)
	if (locale === "hu") return hu_site_hours(inputs)
	return en_site_hours(inputs)
});